// extracted by mini-css-extract-plugin
export default {"content":"share-profile-modal_content__fOgLd patterns_scrollBody__ksWzg"};